import { useMemo } from "react";
import SidePanelMenuItem from "./SidePanelMenuItem";
import MiMLogo from "../../assets/images/mim-logo.png";

const SidePanel = () => {
  const menuItems = [
    { description: "Home", href: "/" },
    { description: "Organisation & Accounts", href: "/organisations" },
  ];

  const currentPath = useMemo(() => window.location.pathname, []);

  return (
    <aside id="sidebar" className="sidebar bg-grey-dark gap-10">
      <div className="px-6 py-10 flex justify-center">
        <img src={MiMLogo} alt="MiM logo" className="w-20" />
      </div>
      <div className="sidebar__holder">
        <ul
          className="nav flex-column px-4 flex flex-col gap-2"
          data-variant="vertical"
        >
          {menuItems.map((item) => (
            <SidePanelMenuItem
              key={item.href}
              {...item}
              isActive={
                item.href === "/"
                  ? currentPath === item.href // special case for home
                  : currentPath.startsWith(item.href)
              }
            />
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default SidePanel;
